const breakpoints = {
  /* semantic palette */
  max: {
    sm: "@media screen and (max-width: 541px)",
    md: "@media screen and (max-width: 800px)",
    lg: "@media screen and (max-width: 1025px)",
  },
};
export default breakpoints;
